/**
 *
 * Asynchronously loads the component for Cart
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UnionRepresentative = lazyLoad(
  () => import('./index'),
  module => module.UnionRepresentative,
);
